import React from 'react';

interface Props {
  inputName: string;
  selectedYear: number | null;
  years: number[];
  onSelect: (year: number) => void;
}

export default function StatisticsYearRadioGroup({
  inputName,
  selectedYear,
  years,
  onSelect,
}: Props) {
  return (
    <div className='flow-root'>
      <div className='-mx-4 flex flex-wrap items-center divide-x divide-gray-200'>
        {years.map((year, index) => (
          <div
            key={year}
            className='relative flex xl:items-start border-gray-200 px-4 sm:py-6 md:py-6 lg:py-6 xl:py-0 items-center gap-3'
          >
            <div className='flex items-center h-5'>
              <input
                type='radio'
                id={`${inputName}-${index}`}
                name={inputName}
                value={year}
                checked={selectedYear === year}
                onChange={() => onSelect(year)}
                className='focus:ring-primary h-4 w-4 text-primary border-primary rounded-full '
              />
            </div>
            <label
              htmlFor={`${inputName}-${index}`}
              className=' text-sm font-normal text-gray-700 '
            >
              {year}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
